import { Typography } from "@mui/material";
import DeleteIcon from "components/SVGs/Delete";
import ExcelDownloadIcon from "assets/images/ExcelDownload.png";
import { DragEvent } from "react";
import { useTranslation } from "react-i18next";
import { IFile } from "../../../Content/useFileBuilder";

interface ILoadedViewProps {
  removeHandler(): void;
  fileValid: boolean;
  file: IFile;
}
export function LoadedView({
  removeHandler,
  fileValid,
  file,
}: ILoadedViewProps) {
  const { i18n } = useTranslation();
  const dragOverHandler = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  return (
    <Typography
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        position: "relative",
        userSelect: "none",
      }}
      onDrop={dragOverHandler}
      onDragOver={dragOverHandler}
    >
      <DeleteIcon
        sx={{
          background: "rgb(105 123 140)",
          borderRadius: "50%",
          height: "25px",
          width: "28px",
          padding: "5px",
          margin: "5px 0",
          cursor: "pointer",
          position: "absolute",
          top: "5px",
          [i18n.dir() === "rtl" ? "left" : "right"]: "8px",
          "&> path": { fill: "rgb(255 255 255)" },
        }}
        onClick={removeHandler}
      />
      <img
        src={ExcelDownloadIcon}
        style={{ width: "44px" }}
        alt="students upload sample excel"
      />
      <span style={{ padding: "5px", fontSize: "12px", fontWeight: "bold" }}>
        {fileValid ? file.fileName : ""}
      </span>
    </Typography>
  );
}
